/**
 * Add CookieBot settings button features
 * Clicking the button will open The CookieBot settings
 * Make sure to add a button element to site (footer preferably) with an id: "cookieBotSettings"
 */
function cookieBotSettings() {
	// Get the CookieBot setting button id
	const cookieBotSettingsBtn = document.querySelector('#cookieBotSettings');

	const init = () => {
		if (cookieBotSettingsBtn) {
			cookieBotSettingsBtn.addEventListener('click', () => {
				Cookiebot?.renew(); // eslint-disable-line no-undef
			});
		}
	};

	init();
}

export default cookieBotSettings;
